import {GameChatPanel, PlayersPanel, usePlayers} from '@glark-newco/game-library';
import {Stack} from '@mantine/core';
import {useEffect, useState} from 'react';
import {CustomiseCharacter} from './CustomiseCharacter';
import {FacilitatorActions} from './FacilitatorActions';
import {IdentityCard} from './IdentityCard';
import {RulesButton} from './RulesButton';
import {SignlinesAvatarProvider} from './SignlinesAvatar';
import {AvatarInterface, defaultAvatar} from '../hooks/usePlayerAvatars';
import {usePlayerAvatar} from '../state/signlinesAvatarSlice';
import {useAvatarEdit} from '../state/useAvatarEdit';


export function LobbyOverlay() {
    const {localPlayer} = usePlayers();
    const [avatarEditState] = useAvatarEdit();
    const [tempAvatar, setTempAvatar] = useState<AvatarInterface>(defaultAvatar);
    const playerAvatar = usePlayerAvatar(localPlayer.playerId);
    
    useEffect(() => {
        setTempAvatar(playerAvatar);
    }, [playerAvatar]);

    return (
        <>
            <PlayersPanel
                avatar={SignlinesAvatarProvider}
                style={{
                    width: '18%',
                    height: '65%',
                    backgroundColor: 'rgba(0,0,0,0.0)',
                    left: '4%',
                    top: '24%',
                }}/>
            {avatarEditState
                ? <CustomiseCharacter
                    tempAvatar={tempAvatar}
                    setTempAvatar={setTempAvatar}/>
                : <></>}
            <IdentityCard
                playerAvatar={playerAvatar}
                tempAvatar={tempAvatar}
                setTempAvatar={setTempAvatar}/>
            <Stack gap={0}>
                {localPlayer.isFacilitator &&
                    <FacilitatorActions/>
                }
                <RulesButton startOpen={false}/>
                <GameChatPanel avatar={SignlinesAvatarProvider} style={{
                    right: '4%',
                    top: '10%',
                    width: '18%',
                    height: '75%',
                    backgroundColor: 'rgba(0,0,0,0)'}}/>
            </Stack>
        </>
    );
}
